import React, { Dispatch, useEffect } from 'react'
import { AuthStateType, Reducer, InitialState } from './UserReducer'
import { ActionType, initTokenAction } from './Actions'
import { storageKeyAuth } from '../model/StorageKeys';

const StateContext = React.createContext<AuthStateType | undefined>(undefined)
const DispatchContext = React.createContext<Dispatch<ActionType> | undefined>(undefined)

export default function AuthProvider(props: React.PropsWithChildren<{}>) {

  const [state, dispatch] = React.useReducer<React.Reducer<AuthStateType, ActionType>>(Reducer, InitialState)

  // Load the stored state once at launch
  useEffect(() => {
    async function loadState() {
      const jsonValue = await localStorage.getItem(storageKeyAuth)
      if (jsonValue != null){
        dispatch(initTokenAction(JSON.parse(jsonValue)));
      }
    }
    loadState();
  }, []);

  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch} {...props}/>
    </StateContext.Provider>
  );
}


export { StateContext, DispatchContext }
